module.exports = __webpack_public_path__ + "assets/img/3q.30df7adf.png";